import * as v from 'valibot';

import { type Entities, type Option, optionSchema } from './_core.model';

export const contractStatusesApiSchema = v.array(v.string());

export type ContractStatusesApi = v.InferOutput<typeof contractStatusesApiSchema>;

export const contractStatusSchema = optionSchema;

export type ContractStatus = Prettify<Option>;

export type ContractStatuses = Entities<ContractStatus>;
